import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Camera, ArrowLeft, Send, X, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Layout";

export default function MobileCapture() {
  const nav = useNavigate();
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const cam = useRef();
  const add = (list) => setFiles((f) => [...f, ...[...list].map((file) => ({ file, url: URL.createObjectURL(file) }))]);
  const send = async () => {
    setBusy(true);
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f.file));
    try {
      await api.post("/scans", fd);
      toast.success("Photos envoyées dans la file « Factures à traiter »");
      setFiles([]);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="flex min-h-screen flex-col bg-[#16163F] text-white">
      <header className="flex items-center justify-between p-4">
        <button onClick={() => nav("/factures-a-traiter")} className="rounded-full p-2 hover:bg-white/10" data-testid="capture-back-btn"><ArrowLeft /></button>
        <Logo light />
        <span className="w-10" />
      </header>
      <div className="flex-1 px-5">
        <h1 className="text-2xl font-extrabold">Photographier une facture</h1>
        <div className="mt-2 h-0.5 w-10 bg-[#A5894E]" />
        <p className="mt-3 text-sm text-white/70">Posez la facture à plat, bien éclairée. Une photo par page ; l'image est redressée et le contraste corrigé automatiquement.</p>
        <div className="mt-6 grid grid-cols-3 gap-3" data-testid="capture-previews">
          {files.map((f, i) => (
            <div key={i} className="relative aspect-[3/4] overflow-hidden rounded-lg border border-[#A5894E]/50">
              <img src={f.url} alt="" className="h-full w-full object-cover" />
              <button onClick={() => setFiles(files.filter((_, j) => j !== i))} className="absolute right-1 top-1 rounded-full bg-black/60 p-1"><X size={14} /></button>
            </div>
          ))}
        </div>
      </div>
      <input ref={cam} type="file" accept="image/*" capture="environment" hidden onChange={(e) => { add(e.target.files); e.target.value = ""; }} data-testid="capture-file-input" />
      <div className="sticky bottom-0 space-y-3 bg-[#16163F] p-5">
        <button onClick={() => cam.current.click()} className="flex w-full items-center justify-center gap-3 rounded-xl bg-[#A5894E] py-5 text-lg font-extrabold text-[#16163F]" data-testid="capture-photo-btn"><Camera /> Prendre une photo</button>
        <button onClick={send} disabled={!files.length || busy} className="flex w-full items-center justify-center gap-3 rounded-xl border border-white/30 py-4 font-bold disabled:opacity-40" data-testid="capture-send-btn">
          {busy ? <Loader2 className="animate-spin" /> : <Send size={18} />} Envoyer {files.length ? `(${files.length})` : ""}
        </button>
      </div>
    </div>
  );
}
